/**
 *  Select script file
**/
import { clickOutside } from '../../../directives/click-outside'

export default {
  name: 'app-select',
  mixins: [],
  components: {},
  directives: {
    clickOutside
  },
  props: {
    items: {
      type: Array,
      required: false
    },
    propToDisplay: {
      type: String,
      required: false,
      default: 'name' || 'value' || 'label'
    },
    selected: {
      type: [String, Number, Array],
      required: false
    },
    multiselect: {
      type: Boolean,
      default: false,
      required: false
    },
    expanded: {
      type: Boolean,
      required: false
    },
    clickOutside: {
      type: Boolean,
      default: true
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    selectAll: {
      type: Object,
      required: false
    },
    search: {
      type: Boolean,
      default: false,
      required: false
    },
    placeholder: {
      type: String,
      default: 'Search',
      required: false
    },
    noResultsText: {
      type: String,
      default: 'No results',
      required: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      open: false,
      someSelected: false,
      selectedIds: [],
      filtered: [],
      noResults: false
    }
  },
  created () {
    if (this.selectAll) {
      this.someSelected = true
    }

    this.filtered = [...this.items]
  },
  mounted () {
    this.selectedIds = this.selected
      ? Array.isArray(this.selected) ? this.selected : [this.selected.id]
      : this.selectAll ? [this.selectAll.id] : null

    this.open = !!this.expanded
  },
  computed: {
  },
  methods: {
    hasSlot (name) {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    },
    toggle (value) {
      this.open = value || !this.open
      this.$emit('toggle')

      if (this.open && this.search) {
        this.$nextTick(() => {
          this.$refs.input.value = ''
          this.$refs.input.focus()
          this.$refs.scrollbar.update()
        })
      }
    },
    tryClose () {
      if (this.clickOutside && this.open) {
        this.close()
      }
    },
    close () {
      this.open = false
      this.noResults = false
      this.filtered = [...this.items]
      this.$emit('input', '')
    },
    onItemClick (item) {
      this.selectedIds = this.multiselect ? [...this.selectedIds, item.id] : item.id
      this.someSelected = true
      this.$emit('select', item)

      if (this.closeOnSelect) {
        this.close()
      }
    },
    onSelectAll () {
      this.$emit('select', 'all')

      if (this.closeOnSelect) {
        this.close()
      }
    },
    onInput (ev) {
      const value = ev.target.value.toLowerCase()
      if (!this.remote) {
        if (value.length > 1) {
          this.filtered = this.items.filter(item => String(item.name).toLowerCase().indexOf(value) > -1)
          this.noResults = !this.filtered.length
        } else {
          this.filtered = [...this.items]
          this.noResults = false
        }
      }

      this.$emit('input', value)
      this.$nextTick(() => this.$refs.scrollbar.update())
    },
    enter (element) {
      element.style.height = 'auto'
      const height = getComputedStyle(element).height
      element.style.height = 0
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => { element.style.height = height })
      setTimeout(() => { this.$refs.scrollbar.update() }, 300)
    },
    afterEnter (element) {
      element.style.height = 'auto'
    },
    leave (element) {
      const height = getComputedStyle(element).height
      element.style.height = height
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => { element.style.height = 0 })
    }
  },
  watch: {
    open (value) {
      this.open = value || false
    },
    items (items) {
      // if (this.remote) {
      //   this.filtered = [...items]
      //   this.noResults = !this.filtered.length
      // }
      this.filtered = [...items]
      this.noResults = !this.filtered.length
    }
  }
}
